module.exports = __webpack_public_path__ + "static/media/heart-filled.bf5dc32c.svg";